/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CreditorInstitutionView } from "./CreditorInstitutionView";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const CreditorInstitutionsViewR = t.interface({
  creditor_institutions: t.readonlyArray(
    CreditorInstitutionView,
    "array of CreditorInstitutionView"
  ),

  page_info: PageInfo
});

// optional attributes
const CreditorInstitutionsViewO = t.partial({});

export const CreditorInstitutionsView = t.intersection(
  [CreditorInstitutionsViewR, CreditorInstitutionsViewO],
  "CreditorInstitutionsView"
);

export type CreditorInstitutionsView = t.TypeOf<
  typeof CreditorInstitutionsView
>;
